(function () {
    'use strict';

    angular.module("imApp").factory("stockTransferCreateService", ['$ihttp', function ($ihttp) {
        let service = {
            saveToPrevious: function (item) {
                return $ihttp.post({
                    method: 1059,
                    parameters: item
                });
            }
        };

        return service;
    }]);
})();
